import { useEffect, useState } from 'react';

export function useWindowWidth() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const windowWidthSetter = () => setWindowWidth(window.innerWidth);
    const resizeHandler = () => {
      // setTimeout нужен, чтобы обойти баг на IOS: https://bugs.webkit.org/show_bug.cgi?id=170595
      setTimeout(windowWidthSetter, 50);
    };

    window.addEventListener('resize', resizeHandler);
    return () => window.removeEventListener('resize', resizeHandler);
  }, []);

  return windowWidth;
}
